import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { useNavigate } from 'react-router';

interface CategoryInter {
  id: number;
  slug: string;
  name: string;
}

interface HeaderStruc {
  social: string;
  emails: string;
  number: string;
  logo:string;
}

const Header = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const navigate = useNavigate();
  const[keyword, setKeyword] = useState('');

const handleSearch = () => {
  if (keyword.trim()) {
    navigate(`/search/${encodeURIComponent(keyword.trim())}`);
  }
};

  const [tags, setTags] = useState<CategoryInter[]>([]);
  const [headerData, setHeaderData] = useState<HeaderStruc | null>(null);

  const today = new Date();
  const formattedDate = today.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: '2-digit',
    year: 'numeric',
  });

  useEffect(() => {
    fetchTags();
    fetchHeader();
  }, []);

  const fetchTags = async () => {
    try {
      const res = await axios.get<CategoryInter[]>(`${api}/auth/category`);
      setTags(res.data);
    } catch (err) {
      console.error('Error fetching category:', err);
    }
  };

  const fetchHeader = async () => {
    try {
      const res = await axios.get<HeaderStruc>(`${api}/auth/siteinfo`);
      setHeaderData(res.data);
      console.log('res.data, ', res.data);
    } catch (err) {
      console.error('Error fetching site info:', err);
    }
  };

  // Parse social
  let socials: { icon: string; link: string }[] = [];
  if (headerData?.social) {
    try {
      socials = JSON.parse(headerData.social);
    } catch (e) {
      console.error('Invalid social JSON', e);
    }
  }

  return (
    <header className='bg-gray-200 relative z-[50] '>
      <div className='container mx-auto flex flex-col lg:flex-row justify-around  items-center  mb-6 pt-2 space-x-4'>

        {/* Social Icons */}
        <div className="flex gap-4">
          {socials.map((social, index) => (
            <a key={index} href={social.link || '#'} target="_blank" rel="noreferrer">
              <img
                className="h-7 w-7"
                src={`${api}/${social.icon.replace(/\\/g, '/')}`}
                alt={`social-icon-${index}`}
              />
            </a>
          ))}
        </div>

        {/* Logo and Date */}
        <div className='flex flex-col items-center text-center'>
          <a href="/">
            <img className='h-9 mb-2' src={`${api}/${headerData?.logo}`} alt="logo" />
          </a>
          <p className='text-lg font-medium'>{formattedDate}</p>
        </div>

        {/* Search Bar */}
        <div className='flex items-center w-full sm:w-auto justify-center gap-2'>
          <input
            className='h-11 w-full sm:w-64 border border-blue-500 rounded-md pl-4'
            type="text"
            placeholder='Search'
            value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          />
          <button className='px-4 py-2 border border-green-500 rounded-md bg-gray-200 text-green-700 text-sm sm:text-base'
          onClick={handleSearch}
          >
            Search
          </button>
        </div>
      </div>

      {/* Emails and Numbers */}
      <div className="container mx-auto flex flex-col sm:flex-row gap-4 justify-start pl-24 !hidden items-center pb-2 text-sm space-x-4">
        <div className="flex flex-col sm:flex-row gap-2">
          {headerData?.emails &&
            headerData.emails.split(',').map((email, index) => (
              <a key={index} href={`mailto:${email.trim()}`} className="text-blue-600 hover:underline">
                📧 {email.trim()}
              </a>
            ))}
        </div>
        <div className="flex flex-col sm:flex-row gap-2">
          {headerData?.number &&
            headerData.number.split(',').map((num, index) => (
              <a key={index} href={`tel:${num.trim()}`} className="text-blue-600 hover:underline">
                📞 {num.trim()}
              </a>
            ))}
        </div>
      </div>

      {/* Menu Bar */}
      <nav className='bg-black text-gray-300 overflow-x-auto whitespace-nowrap relative z-[9999]'>
        <ul className='flex gap-4 sm:gap-6 md:gap-10 justify-center px-2 sm:px-4 md:px-8 py-2 sm:py-3 text-xs sm:text-sm md:text-base lg:text-lg font-semibold relative'>
          {tags.map((item, index) => (
            <li key={index} className='relative z-[9999]'>
              <a
                href={`/category/${item.slug}`}
                className='hover:text-white transition-all relative after:absolute after:-bottom-1 after:left-0 after:w-full after:h-[2px] after:bg-red-500 after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:origin-left'
              >
                {item.name}
              </a>
              {item.name === "E-Paper" && (
                <span className="absolute -top-5 -right-4 text-[8px] sm:text-[9px] bg-yellow-400 text-black px-1 rounded animate-blink tracking-wider">
                  Click Here
                </span>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
